import { useTranslation } from 'next-i18next';
import SortingIcon from '@public/images/icon-sort.svg';
import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import styles from './SectionSorting.module.scss';

type Props = {
    submitSorting: (e: string) => void;
    currentSorting?: string;
    isZHCN?: boolean;
    showStyle?: boolean;
    prefName?: string;
    top?: string;
};

export default function SectionSorting({
    submitSorting,
    isZHCN = false,
    showStyle = false,
    top = '50',
    currentSorting,
}: Props) {
    const { t } = useTranslation();

    const [selectType, setSelectType] = useState('Relevance');
    const [toggle, setToggle] = useState(false);
    const [onTop, setOnTop] = useState(false);

    const selectFun = useCallback(
        (key: string) => {
            setSelectType(key);
            submitSorting(key);
            setToggle(false);
            sessionStorage.setItem('hasTagSortingKey', key);
        },
        [submitSorting]
    );

    useEffect(() => {
        if (currentSorting !== undefined) {
            setSelectType(currentSorting);
        }
    }, [currentSorting]);

    useEffect(() => {
        if (!showStyle) return;

        const handleScroll = () => {
            setOnTop(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [showStyle]);

    return (
        <div className='py-[16px]'>
            <div className='z-30 relative flex flex-row-reverse'>
                {showStyle && onTop && !toggle && (
                    <div className='h-[50px] w-[100vw] absolute top-[-16px] left-0 bg-[rgba(246,247,248,0.8)] text-[18px] text-center leading-[50px]'>
                        {/* {prefName} */}
                    </div>
                )}
                <div className='z-10'>
                    <SortingIcon
                        onClick={() => {
                            setToggle(!toggle);
                        }}
                    />
                </div>
            </div>
            {toggle && (
                <div
                    className={`w-[100vw] h-[100vh] absolute bg-[rgba(0,0,0,0.4)] z-20 flex flex-col ${
                        showStyle ? 'left-0' : 'left-[-17px]'
                    }`}
                    style={{ maxWidth: '1440px', top: `${top}px` }}
                >
                    {showStyle && (
                        <div
                            className='h-[50px] w-full absolute top-[-50px] left-0 bg-[rgba(246,247,248,0.8)] text-[18px] text-center leading-[50px]'
                            onClick={() => {
                                setToggle(false);
                            }}
                        >
                            {/* {prefName} */}
                        </div>
                    )}
                    <div className='bg-white p-[15px] pb-[40px] md:w-[50vw] md:self-end'>
                        <div className='mb-[20px] font-bold'>
                            {isZHCN ? '排序依据' : t('sortBy')}
                        </div>
                        <div className='flex flex-col'>
                            <div
                                className='flex mb-[10px]'
                                onClick={() => {
                                    selectFun('Relevance');
                                }}
                            >
                                <div className='w-[20px]'>
                                    {selectType === 'Relevance' && (
                                        <div className={styles.gou}></div>
                                    )}
                                </div>
                                <div
                                    className={classnames(
                                        selectType === 'Relevance' && styles.selected
                                    )}
                                >
                                    {isZHCN ? '关联性' : t('Relevance')}
                                </div>
                            </div>
                            <div
                                className='flex'
                                onClick={() => {
                                    selectFun('Newest');
                                }}
                            >
                                <div className='w-[20px]'>
                                    {selectType === 'Newest' && <div className={styles.gou}></div>}
                                </div>
                                <div
                                    className={classnames(
                                        selectType === 'Newest' && styles.selected
                                    )}
                                >
                                    {isZHCN ? '上传日期' : t('newest')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className='flex-1'
                        onClick={() => {
                            setToggle(false);
                        }}
                    ></div>
                </div>
            )}
        </div>
    );
}
